import React from "react";
import { Table } from "antd";
import "./style.css";

const GenericTable = ({ title, dataSource, columns, loading }) => {
  return (
    <div className="table-generic">
      <div className="title">
        <span>{title}</span>
      </div>

      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey={(record, index) => record.key || index}
        pagination={true}
        loading={loading}
        bordered
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default GenericTable;
